import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import getSeeksColumns from '../../../const/columns/SeeksColumns'
import { getSeeksServer } from '../../../apis/seeksApi'

const Seeks = () => {
  const [seeks, setSeeks] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchSeeks()
  }, [])

  const fetchSeeks = async () => {
    try {
      const res = await getSeeksServer()
      setSeeks(res.result)
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }

  const columns = getSeeksColumns()
  return (
    <>
      <div className='main-wrapper'>
        <div className='page-wrapper'>
          <div className='content container-fluid'>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className='table-respoinsive'>
                <Table
                  columns={columns}
                  dataSource={seeks?.length > 0 ? seeks : []}
                  className='table-striped '
                  rowKey={record => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Seeks
